/**
 * SwitchSlotHeader 子组件
 * 渲染标题旁的切换控件区域，支持两种渲染模式：
 * 1. byDataKey 模式：使用 Render 组件配置化渲染
 * 2. 默认模式：通过 componentMap 动态创建组件
 */
import React from 'react';
import componentMap from '../../_config/compConfig';
import Render from '../PageContainer/Render';
import { SwitchSlotHeaderProps } from './type';

export default function SwitchSlotHeader({
  switchSlot,
  shouldRenderByDataKey,
  data,
  switchData,
  changeData,
}: SwitchSlotHeaderProps) {
  // byDataKey 模式：使用 Render 配置化渲染，清空 children 防止重复渲染
  if (shouldRenderByDataKey) {
    const switchConfig = { ...switchSlot, children: [] };
    return (
      <Render
        config={switchConfig}
        data={{ ...data, ...switchData }}
        changeData={changeData}
      />
    );
  }

  // 默认模式：从 componentMap 查找对应组件并动态创建
  const { name, props: slotProps, ...restProps } = switchSlot;
  const slotComponent = componentMap?.[name];

  if (!slotComponent) return null;

  return React.createElement(slotComponent, {
    ...restProps,
    ...slotProps,
    switchData,
    data,
    changeData,
  });
}
